module.exports = __webpack_public_path__ + "img/swiper4_t.2f4ba42e.png";